module.exports = __webpack_public_path__ + "img/naga_siren_small.0f2de79a.png";